import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import * as styles from './styles';
import { Button } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';
import { Badge, Tooltip } from '@material-ui/core';

import { Location, OnboardingStatus } from '@cobliteam/common-types';

import { useOnboardingStore, useUpdateOnboarding } from '@cobliteam/onboarding';

import { BookIcon, ProgressBar } from '@cobliteam/base-components';

import Icon from '@cobliteam/ui/icons';

interface SidebarOnboardingProps {
  isSidebarUser?: boolean;
  sidebarOpen?: boolean;
}

const SidebarOnboarding = ({ isSidebarUser, sidebarOpen }: SidebarOnboardingProps) => {
  const onboardingShowSidebar = useOnboardingStore((state) => state.onboardingShowSidebar);
  const setOnboardingShowSidebar = useOnboardingStore((state) => state.setOnboardingShowSidebar);
  const onboardingStepsTotal = useOnboardingStore((state) => state.onboardingStepsTotal);
  const onboardingStepsIndex = useOnboardingStore((state) => state.onboardingStepsIndex);
  const hasOnboarding = useOnboardingStore((state) => state.hasOnboarding);
  const onboardingStatus = useOnboardingStore((state) => state.onboardingStatus);
  const onboardingFinished = onboardingStatus === OnboardingStatus.COMPLETED;

  const { dismissOnboarding } = useUpdateOnboarding();

  const history = useHistory();
  const handleBack = () => history.push(Location.ONBOARDING_SETUP);

  useEffect(() => {
    if (onboardingFinished) {
      setOnboardingShowSidebar(false);
    }
  }, [onboardingFinished, setOnboardingShowSidebar]);

  const renderSideBarOnboarding = (
    <div className={cn('relative flex items-start p-5', isSidebarUser ? 'flex-col-reverse' : 'flex-col', sidebarOpen && 'shadow-md')}>
      <Button variant='text' endIcon={<Icon name='chevron-right' />} className='font-normal text-white hover:bg-transparent hover:font-bold hover:text-white' onClick={handleBack}>
        Voltar ao guia
      </Button>
      <div className='flex w-full items-center gap-1 text-white'>
        <ProgressBar currentStep={onboardingStepsIndex} totalSteps={onboardingStepsTotal} />
        {onboardingStepsIndex}/{onboardingStepsTotal}
      </div>
      {!isSidebarUser && <Button variant='text' color='default' size='condensed' icon={<Icon name='x' />} className='absolute top-2 right-2 size-8' onClick={dismissOnboarding} />}
    </div>
  );

  const SidebarComponent = () => {
    if (sidebarOpen || isSidebarUser) return renderSideBarOnboarding;

    return (
      <Tooltip title='Voltar ao guia' aria-label='add'>
        <div className={styles.itemContainer}>
          <Button variant='text' className='font-normal text-white hover:font-bold hover:text-white' onClick={handleBack} asChild>
            <Badge
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              badgeContent={`${onboardingStepsIndex}/${onboardingStepsTotal}`}
            >
              <BookIcon />
            </Badge>
          </Button>
        </div>
      </Tooltip>
    );
  };

  // show sidebar onboarding for non-sidebar user
  if (!isSidebarUser && onboardingShowSidebar === false) return null;

  // hide sidebar onboarding for sidebar user
  if (isSidebarUser && onboardingShowSidebar === true) return null;

  // hide sidebar if user does not have onboarding
  if (!hasOnboarding) return null;

  return <SidebarComponent />;
};

export default SidebarOnboarding;
